module.exports = __webpack_public_path__ + "img/6.254cba53.png";